<template>
  <div class="childrendiv">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item>
        <el-button type="primary" @click="childAdd">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-input v-model="queryForm.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" icon="el-icon-search" circle @click="serch()"></el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 99%">
      <el-table-column type="index" width="50"></el-table-column>
      <!-- 
      <el-table-column
        prop="id"
        label="ID"
        width="150">
      </el-table-column>-->

      <el-table-column prop="type_name" label="新闻类型" align="center" width="150"></el-table-column>

      <el-table-column prop="title" label="新闻标题" align="center" width="150"></el-table-column>

      <el-table-column prop="title_en" label="英文标题" align="center" width="150"></el-table-column>

      <!-- <el-table-column
        label="封面图"
        >
        <template slot-scope="scope">
          <img height="100px" class="img" :src="scope.row.thumbnail" alt="">
        </template>
      </el-table-column>-->

      <el-table-column prop="introduce" align="center" label="新闻简介" width="300"></el-table-column>

      <el-table-column prop="introduce_en" label="英文简介" align="center" width="400"></el-table-column>

      <el-table-column prop="time" label="新闻时间" align="center" width="150"></el-table-column>

      <el-table-column label="新闻图片" width="200" align="center">
        <template slot-scope="scope">
          <img height="100px" class="img" :src="scope.row.images" alt />
        </template>
      </el-table-column>

      <el-table-column prop="content" label="新闻内容" align="center" width="180">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div
              slot="content"
              style="padding: 1% 2%;margin:0;background:grey;"
              v-html="scope.row.content"
            ></div>
            <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
              <button>移入查看内容</button>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="content_en" label="英文内容" align="center" width="180">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div
              slot="content"
              style="padding: 1% 2%;margin:0;background:grey;"
              v-html="scope.row.content_en"
            ></div>
            <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
              <button>移入查看内容</button>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="权重" prop="order" width="150" align="center"></el-table-column>

      <el-table-column label="状态" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            @click="isStatus(scope.row)"
            size="mini"
            :type="scope.row.status==1 ? 'success':'info'"
            round
            ref="button"
          >{{scope.row.statusCH}}</el-button>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="fenye">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10,20]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from "../../components/dashu/backfooter";
export default {
  components: { Backfooter },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pageVal: 1,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      id: "",
      queryForm: {
        keyword: "",
        images: ""
      },
      headers: {
        Authorization: ""
      },
      tableData: [
        {
          order: "",
          date: "",
          title: "",
          address: " ",
          intro: "",
          img: ""
        },
        {
          order: "",
          date: "",
          title: "",
          address: "",
          intro: "",
          img: ""
        }
      ],
      childVisible: false
    };
  },
  methods: {
    serch() {
      this.$http
        .post("/admin/dashu/news/newList", {
          page: this.pageVal,
          pageSize: this.pageSize,
          noPaginate: 1,
          keyword: this.queryForm.keyword
        })
        .then(res => {
          //  console.log(res.data.data.list)
          var code = res.data.code;
          if (code === 0) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    isStatus(row) {
      this.$confirm("是否改变状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/admin/dashu/news/changeStatus", {
              id: row.id
            })
            .then(res => {
              var code = res.data.code;
              if (code === 0) {
                this.$message({
                  type: "success",
                  message: "改变成功!"
                });
                this.getList();
              }
            })
            .catch(function(error) {
              // console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    childAdd() {
      this.$router.push({
        name: "backCaseAdd",
        query: { type: "backChildren" }
      });
      // this.childVisible = true
      // this.flag=1;
      //  this.$refs.upload.clearFiles();
    },
    compile(row) {
      this.$router.push({
        name: "backCaseEdit",
        query: { type: "backChildren", id: row.id }
      });
    },
    getList() {
      this.$http
        .post("/admin/dashu/news/newList", {
          page: this.pageVal,
          pageSize: this.pageSize,
          noPaginate: 1
        })
        .then(res => {
          //  console.log(res)
          var code = res.data.code;
          if (code === 0) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    // 删除
    del(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.id = row.id;
          this.$http
            .post("/admin/dashu/news/delete", {
              id: this.id
            })
            .then(res => {
              var code = res.data.code;
              if (code === 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getList();
              }
            })
            .catch(function(error) {
              //  console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      //  console.log(`当前页: ${val}`);
      this.pageVal = val;
      this.getList();
    }
  },
  created() {
    this.headers.Authorization = window.localStorage.getItem("user_token");
    this.getList();
  },
  mounted() {},
  computed: {
    getUeData() {
      return this.$store.state.ueData;
    }
  },
  watch: {
    getUeData: function(old, newd) {
      // console.log(old)
      this.dataF = old;
    }
  }
};
</script>
<style scoped>
</style>
<style>
.fenye .el-pagination {
  text-align: center;
  margin-top: 50px;
}
.childrendiv {
  position: relative;
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/children.vue